import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { apiClient, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await apiClient.post("/auth/reset-password", { token, new_password: password });
      navigate("/login");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return <div className="max-w-md mx-auto px-6 py-24 text-center text-sm text-red-500" data-testid="reset-password-no-token">Invalid or missing reset token. <Link to="/forgot-password" className="text-brandblue-600 font-semibold">Request a new link</Link></div>;
  }

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="reset-password-page">
      <h1 className="text-2xl font-display font-medium text-slate-900 text-center mb-8">Set New Password</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div><Label>New Password</Label><Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" /></div>
        {error && <p className="text-xs text-red-500">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full rounded-full btn-lift" data-testid="reset-password-submit-btn">
          {loading ? "Updating..." : "Update Password"}
        </Button>
      </form>
    </div>
  );
}
